"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AlertDialog_1 = __importDefault(require("@/components/AlertDialog"));
function RemoveAssociationDialogView({ isOpen, onClose, onDismiss, onProceed, componentToBeUnlinkedName, }) {
    const text = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("strong", null, componentToBeUnlinkedName),
        " will be removed from its product."));
    return isOpen ? (react_1.default.createElement(AlertDialog_1.default, { dialogTitle: `Remove "${componentToBeUnlinkedName}"?`, dismissActionLabel: "Cancel", text: text, proceedWithActionLabel: "Remove", isOpen: isOpen, onClose: onClose, onDismiss: onDismiss, onProceed: onProceed })) : null;
}
exports.default = RemoveAssociationDialogView;
